import { ExtraAppCreateModal } from "../../features/ExtraApp/components/ExtraAppCreateModal";
import { Sidebar } from "../../common/AppSidebar";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const ExtraAppPage = () => {
  const { handleOpenModal, handleCloseModal } = useAppModals();
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("ai_agents_extra_app");
  const { handleSelectObject } = useStorageObject(
    "ai_agents_extra_app",
    "ai_agents_extra_app",
    currentService,
  );
  useServiceNavigate("ai_agents_extra_app", "ai_agents_extra_app");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() =>
          handleOpenModal("manage_extra_app_modal", null, "create_extra_app")
        }
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"ai_agents_extra_app"}
        isLoading={isLoading ?? false}
        customCreateObject={(info) =>
          handleOpenModal("manage_extra_app_modal", info, "create_extra_app")
        }
        customEditObject={(info) =>
          handleOpenModal("manage_extra_app_modal", info, "edit_extra_app")
        }
      />
      {selectedObject && <SafeOutlet />}
      <ExtraAppCreateModal closeModal={handleCloseModal} />
    </div>
  );
};
